import React, { useId } from 'react'
import L from 'leaflet'
import { Marker } from 'react-leaflet';

const ProviderMarker = ({ lat, lng, information, index, children }) => {
    const reactId = useId()
    const markerHTML =
        `<span class='arr-bottom arr-provider flex text-4xl w-12 h-12 rounded-full' style="background-color: ${information.provider.color}"'>
            <img src="${information.provider.logo}" class='rounded-full w-full h-full' alt="" />
        </span>`

    // const handleClick = () => {
    //     const detailsElement = document.querySelector(`[data-provider-uid="${information.attributes[0].uid}"]`)
    //     const currentStatus = detailsElement.getAttribute('open')

    //     if(currentStatus) detailsElement.removeAttribute('open')
    //     if(!currentStatus) detailsElement.setAttribute('open', 'true')
    //     detailsElement.scrollIntoView({block: "end", behavior: "smooth"})
    // }

    return (
        <Marker position={[lat, lng]} key={`${reactId}-${index}`}
            // eventHandlers={{ click: handleClick }}
            icon={L.divIcon({
                iconSize: [48, 48],
                iconAnchor: [48 / 2, 48 + 9],
                className: "mymarker rounded-full",
                html: markerHTML,
            })
        }>
            {children}
        </Marker>
    )
}

export default ProviderMarker
